import type { FC } from 'react';
import { Fragment } from 'react';

import { Divider, ListSubheader } from '@packages/shared';

import type { GroupedFilterValues, BasicFilterValue } from '../../api/rest/types';
import { BasicFilterValueItem } from '../BasicFilterValueItem';

export type BasicFilterValueGroupProps = {
  /** A single group of grouped filter values to display */
  group: GroupedFilterValues<BasicFilterValue>;
  /** If `true`, the component uses single selection instead of multiple selection */
  isSingleSelection?: boolean;
  /** Currently selected filter value ids */
  selectedIds: string[];
  /** Callback fired when a filter value item is clicked */
  onItemClick?: (itemId: string) => void;
};

/** Helper component to clean up main component template */
export const BasicFilterValueGroup: FC<BasicFilterValueGroupProps> = ({
  group: { groupName, values },
  isSingleSelection,
  selectedIds,
  onItemClick,
}) => {
  const uniqueSelectedIds = new Set(selectedIds);

  return (
    <>
      {/* NOTE: without disableSticky the list items are visible in a small gap above the ListSubheader */}
      {groupName && values.length ? (
        <ListSubheader disableSticky>{groupName}</ListSubheader>
      ) : (
        false
      )}
      {values.map((value, i) => (
        <Fragment key={value.id}>
          {i > 0 && <Divider />}
          <BasicFilterValueItem
            value={value}
            isSingleSelection={isSingleSelection}
            onClick={onItemClick}
            isSelected={uniqueSelectedIds.has(value.id)}
          />
        </Fragment>
      ))}
    </>
  );
};
